import Header from 'projects/components/list/ProjectsListHeader';
import Filters from 'projects/components/list/ProjectsListFilters';
import Table from 'projects/components/list/ProjectsListTable';
import Row from 'projects/components/list/ProjectsListRow';

export default { Header, Filters, Table, Row };



// WEBPACK FOOTER //
// src/modules/secured/modules/projects/components/list/index.js